import { Locale, type LocalizedString } from "../Locale.js";
import { WeddingCakeSize } from "../WeddingCakeSize.js";

export const weddingCakeSizeNameMap = {
	[WeddingCakeSize.Portions12]: { [Locale.cs]: "12 porcí (1 patro)" },
	[WeddingCakeSize.Portions18]: { [Locale.cs]: "18 porcí (1 patro)" },
	[WeddingCakeSize.Portions25]: { [Locale.cs]: "25 porcí (2 patra)" },
	[WeddingCakeSize.Portions30]: { [Locale.cs]: "30 porcí (2 patra)" },
	[WeddingCakeSize.Portions40]: { [Locale.cs]: "40 porcí (2 patra)" },
	[WeddingCakeSize.Portions50Double]: { [Locale.cs]: "50 porcí (2 patra)" },
	[WeddingCakeSize.Portions50Triple]: { [Locale.cs]: "50 porcí (3 patra)" },
	[WeddingCakeSize.Portions60]: { [Locale.cs]: "60 porcí (3 patra)" },
	[WeddingCakeSize.Portions70]: { [Locale.cs]: "70 porcí (3 patra)" },
	[WeddingCakeSize.Portions80]: { [Locale.cs]: "80 porcí (3 patra)" },
	[WeddingCakeSize.Portions90]: { [Locale.cs]: "90 porcí (3 patra)" },
	[WeddingCakeSize.Portions90Plus]: { [Locale.cs]: "Více než 90 porcí" },
} satisfies Record<WeddingCakeSize, LocalizedString>;

export const weddingCakeSizeShortNameMap = {
	[WeddingCakeSize.Portions12]: { [Locale.cs]: "12 porcí" },
	[WeddingCakeSize.Portions18]: { [Locale.cs]: "18 porcí" },
	[WeddingCakeSize.Portions25]: { [Locale.cs]: "25 porcí" },
	[WeddingCakeSize.Portions30]: { [Locale.cs]: "30 porcí" },
	[WeddingCakeSize.Portions40]: { [Locale.cs]: "40 porcí" },
	[WeddingCakeSize.Portions50Double]: { [Locale.cs]: "50 porcí" },
	[WeddingCakeSize.Portions50Triple]: { [Locale.cs]: "50 porcí" },
	[WeddingCakeSize.Portions60]: { [Locale.cs]: "60 porcí" },
	[WeddingCakeSize.Portions70]: { [Locale.cs]: "70 porcí" },
	[WeddingCakeSize.Portions80]: { [Locale.cs]: "80 porcí" },
	[WeddingCakeSize.Portions90]: { [Locale.cs]: "90 porcí" },
	[WeddingCakeSize.Portions90Plus]: { [Locale.cs]: "Více než 90 porcí" },
} satisfies Record<WeddingCakeSize, LocalizedString>;
